[
  {
    "unCode" : "AMD",
    "description" : "ARMENIE"
  },
  {
    "unCode" : "AOA",
    "description" : "ANGOLA"
  },
  {
    "unCode" : "AZM",
    "description" : "AZERBAIJAN"
  },
  {
    "unCode" : "BBD",
    "description" : "BARBADOS"
  },
  {
    "unCode" : "BIF",
    "description" : "BURUNDI"
  },
  {
    "unCode" : "BSD",
    "description" : "BAHAMAS"
  },
  {
    "unCode" : "BTN",
    "description" : "BHUTAN"
  },
  {
    "unCode" : "BZD",
    "description" : "BELIZE"
  },
  {
    "unCode" : "CVE",
    "description" : "CAPE VERDE"
  },
  {
    "unCode" : "DOP",
    "description" : "DOMINIC. REPUBL."
  },
  {
    "unCode" : "DZD",
    "description" : "ALGERIJE - DINAR"
  },
  {
    "unCode" : "GEL",
    "description" : "GEORGIA - LARI"
  },
  {
    "unCode" : "GGP",
    "description" : "GUERNSEY - POUNDS"
  },
  {
    "unCode" : "GHC",
    "description" : "GHANA - CEDI"
  },
  {
    "unCode" : "HTG",
    "description" : "HAITI - GOURDES"
  },
  {
    "unCode" : "JOD",
    "description" : "JORDANIE - DOLLAR"
  },
  {
    "unCode" : "LAK",
    "description" : "LAOS - KIPS"
  },
  {
    "unCode" : "LRD",
    "description" : "LIBERIE - DOLLARS"
  },
  {
    "unCode" : "LVL",
    "description" : "LETLAND - LAT"
  },
  {
    "unCode" : "MWK",
    "description" : "MALAWI - KWACHA"
  },
  {
    "unCode" : "PEN",
    "description" : "PERU - NUEVOS SOLES"
  },
  {
    "unCode" : "SIT",
    "description" : "SLOUENIE"
  },
  {
    "unCode" : "SOS",
    "description" : "SOMALIA - SHILLINGS"
  },
  {
    "unCode" : "SPL",
    "description" : "SEBORGA - LUIGINI"
  },
  {
    "unCode" : "TJS",
    "description" : "TAJIKISTAN - SOMONI"
  },
  {
    "unCode" : "UZS",
    "description" : "OEZBEKISTAN - SUMS"
  },
  {
    "unCode" : "VEB",
    "description" : "VENEZUELA - BOLIVAR"
  },
  {
    "unCode" : "VND",
    "description" : "VIETNAM - DONG"
  },
  {
    "unCode" : "WST",
    "description" : "SAMOA - TALA"
  },
  {
    "unCode" : "XCD",
    "description" : "EAST CARIBBEAN DOLLARS"
  },
  {
    "unCode" : "CLP",
    "description" : "CHILIE"
  },
  {
    "unCode" : "CRC",
    "description" : "COSTA RICA"
  },
  {
    "unCode" : "ETB",
    "description" : "ETHIOPIA - BIRR"
  },
  {
    "unCode" : "HRK",
    "description" : "KROATIE - KUNA"
  },
  {
    "unCode" : "IMP",
    "description" : "ISLE OF MAN - POUNDS"
  },
  {
    "unCode" : "IRR",
    "description" : "IRAN - RIAL"
  },
  {
    "unCode" : "JEP",
    "description" : "JERSEY - POUNDS"
  },
  {
    "unCode" : "KMF",
    "description" : "COMOROS - FRANCS"
  },
  {
    "unCode" : "KYD",
    "description" : "CAYMAN ISLANDS - DOLLARS"
  },
  {
    "unCode" : "MKD",
    "description" : "MACEDONIE - DENARS"
  },
  {
    "unCode" : "MRO",
    "description" : "MAURITANIE - OUGUIYAS"
  },
  {
    "unCode" : "MUR",
    "description" : "MAURITIUS - RUPEE"
  },
  {
    "unCode" : "MVR",
    "description" : "MALDIVES - RUFIYAA"
  },
  {
    "unCode" : "MZM",
    "description" : "MOZAMBIQUE -METICAIS"
  },
  {
    "unCode" : "NIO",
    "description" : "NICARAGUA - GOLD CORDOBAS"
  },
  {
    "unCode" : "RWF",
    "description" : "RWANDA - RWANDA FRANCS"
  },
  {
    "unCode" : "SCR",
    "description" : "SEYCHELLES - RUPEES"
  },
  {
    "unCode" : "UGX",
    "description" : "UGANDA - SHILLING"
  },
  {
    "unCode" : "VUV",
    "description" : "VANUATU - VATU"
  },
  {
    "unCode" : "XPT",
    "description" : "PLATINUM - OUNCES"
  },
  {
    "unCode" : "BMD",
    "description" : "BERMUDA"
  },
  {
    "unCode" : "BOB",
    "description" : "BOLIVIA"
  },
  {
    "unCode" : "BWP",
    "description" : "BOTSWANA"
  },
  {
    "unCode" : "BYR",
    "description" : "WIT-RUSLAND"
  },
  {
    "unCode" : "GNF",
    "description" : "GUINEA - FRANCS"
  },
  {
    "unCode" : "GYD",
    "description" : "GUYANA - DOLLARS"
  },
  {
    "unCode" : "HNL",
    "description" : "HONDURAS - LEMPIRAS"
  },
  {
    "unCode" : "IQD",
    "description" : "IRAK - DINAR"
  },
  {
    "unCode" : "KHR",
    "description" : "COMBODIA - RIELS"
  },
  {
    "unCode" : "MNT",
    "description" : "MONGOLIE- TUGRIKS"
  },
  {
    "unCode" : "NPR",
    "description" : "NEPAL - NEPALESE RUPEES"
  },
  {
    "unCode" : "SBD",
    "description" : "SOLOMON ISLANDS - DOLLARS"
  },
  {
    "unCode" : "SHP",
    "description" : "SINT HELENA - POUNDS"
  },
  {
    "unCode" : "STD",
    "description" : "SAO TOME AND PRINCIPE  - DOBRAS"
  },
  {
    "unCode" : "UAH",
    "description" : "OEKRAINE - HRYVNIA"
  },
  {
    "unCode" : "XAG",
    "description" : "ZILVER - PONDEN"
  },
  {
    "unCode" : "XAU",
    "description" : "GOUD - PONDEN"
  },
  {
    "unCode" : "XOF",
    "description" : "COMM. FINANC. AFRICANE BCEAO - FRAN"
  },
  {
    "unCode" : "XPD",
    "description" : "PALLADIUM OUNCES"
  },
  {
    "unCode" : "XPF",
    "description" : "COMPT. FRANCAID DU PACIFIQUE FRANCS"
  },
  {
    "unCode" : "YEM",
    "description" : "YEMEN - RIALS"
  },
  {
    "unCode" : "ZMK",
    "description" : "ZAMBIA - KWACHA"
  },
  {
    "unCode" : "ZWD",
    "description" : "ZIMBABWE - DOLLAR"
  },
  {
    "unCode" : "AWG",
    "description" : "Aruba-florin"
  },
  {
    "unCode" : "AED",
    "description" : "Verenigde Arabische Emiraten- dirham"
  },
  {
    "unCode" : "ANG",
    "description" : "Nederlandse Antillen-gulden"
  },
  {
    "unCode" : "AUD",
    "description" : "Australie-dollar"
  },
  {
    "unCode" : "BDT",
    "description" : "Bangladesh-taka"
  },
  {
    "unCode" : "BGL",
    "description" : "Bulgarije-lev"
  },
  {
    "unCode" : "BHD",
    "description" : "Bahrein-Dinar"
  },
  {
    "unCode" : "BND",
    "description" : "Brunei-dollar"
  },
  {
    "unCode" : "BRL",
    "description" : "Brazilie-real"
  },
  {
    "unCode" : "CAD",
    "description" : "Canada-dollar"
  },
  {
    "unCode" : "CZK",
    "description" : "Tsjechie-koruna"
  },
  {
    "unCode" : "CHF",
    "description" : "Zwitserland-franc"
  },
  {
    "unCode" : "CNY",
    "description" : "China-r.m.b. Yuan"
  },
  {
    "unCode" : "CYP",
    "description" : "Cyprus-pond"
  },
  {
    "unCode" : "DKK",
    "description" : "Denemarken-kroon"
  },
  {
    "unCode" : "EGP",
    "description" : "Egypte-pond"
  },
  {
    "unCode" : "EUR",
    "description" : "EURO"
  },
  {
    "unCode" : "FJD",
    "description" : "Fiji-Dollar"
  },
  {
    "unCode" : "GBP",
    "description" : "Verenigd Koninkrijk-pond"
  },
  {
    "unCode" : "GIP",
    "description" : "Gibraltar-pond"
  },
  {
    "unCode" : "GTQ",
    "description" : "Guatemala-Quetzal"
  },
  {
    "unCode" : "HKD",
    "description" : "Hong Kong-dollar"
  },
  {
    "unCode" : "HUF",
    "description" : "Hongarije-florint"
  },
  {
    "unCode" : "IDR",
    "description" : "Indonesie-rupiah"
  },
  {
    "unCode" : "ILS",
    "description" : "Israel-shekel"
  },
  {
    "unCode" : "INR",
    "description" : "India-rupee"
  },
  {
    "unCode" : "ISK",
    "description" : "Ijsland-kroon"
  },
  {
    "unCode" : "JPY",
    "description" : "Japan-yen"
  },
  {
    "unCode" : "KES",
    "description" : "Kenya-shilling"
  },
  {
    "unCode" : "KRW",
    "description" : "Zuid Korea-won"
  },
  {
    "unCode" : "LKR",
    "description" : "Sri Lanka-rupee"
  },
  {
    "unCode" : "MAD",
    "description" : "Marokko-dirham"
  },
  {
    "unCode" : "MOP",
    "description" : "Macao-pataca"
  },
  {
    "unCode" : "MTL",
    "description" : "Malta-Lira"
  },
  {
    "unCode" : "MXN",
    "description" : "Mexico-peso"
  },
  {
    "unCode" : "MYR",
    "description" : "Maleisie-ringgit"
  },
  {
    "unCode" : "NGN",
    "description" : "Nigeria-naira"
  },
  {
    "unCode" : "NOK",
    "description" : "Noorwegen-kroon"
  },
  {
    "unCode" : "NZD",
    "description" : "Nieuw Zeeland-dollar"
  },
  {
    "unCode" : "PHP",
    "description" : "Filippijnen-peso"
  },
  {
    "unCode" : "PKR",
    "description" : "Pakistan-rupee"
  },
  {
    "unCode" : "PLN",
    "description" : "Polen-zloty"
  },
  {
    "unCode" : "QAR",
    "description" : "Qatar-Riyal"
  },
  {
    "unCode" : "RON",
    "description" : "Roemenie-leu"
  },
  {
    "unCode" : "RUR",
    "description" : "Rusland-roebel"
  },
  {
    "unCode" : "SAR",
    "description" : "Saoedi Arabie-ryal"
  },
  {
    "unCode" : "SEK",
    "description" : "Zweden-kroon"
  },
  {
    "unCode" : "SGD",
    "description" : "Singapore-dollar"
  },
  {
    "unCode" : "SKK",
    "description" : "Slowaijke-koruna"
  },
  {
    "unCode" : "SRD",
    "description" : "Suriname-gulden"
  },
  {
    "unCode" : "SZL",
    "description" : "Swaziland-lilangeni"
  },
  {
    "unCode" : "THB",
    "description" : "Thailand-baht"
  },
  {
    "unCode" : "TND",
    "description" : "Tunesie-dinar"
  },
  {
    "unCode" : "TTD",
    "description" : "Trinidad/Tobago-Dollar"
  },
  {
    "unCode" : "TWD",
    "description" : "Taiwan-dollar"
  },
  {
    "unCode" : "USD",
    "description" : "U.S.A.-dollar"
  },
  {
    "unCode" : "XAF",
    "description" : "Centraalafrikaanse Repupliek-frank"
  },
  {
    "unCode" : "CSD",
    "description" : "Servie Montenegro - Dinar"
  },
  {
    "unCode" : "ZAR",
    "description" : "Zuid Afrika-rand"
  },
  {
    "unCode" : "COP",
    "description" : "COLOMBIA"
  },
  {
    "unCode" : "EEK",
    "description" : "ESTLAND - KROON"
  },
  {
    "unCode" : "JMD",
    "description" : "JAMAICA - DOLLARS"
  },
  {
    "unCode" : "KGS",
    "description" : "KIRGIZIE - SOMS"
  },
  {
    "unCode" : "KPW",
    "description" : "NORTH KOREA - WON"
  },
  {
    "unCode" : "KWD",
    "description" : "KOEWEIT - DINAR"
  },
  {
    "unCode" : "KZT",
    "description" : "KAZAKSTAN - TENGE"
  },
  {
    "unCode" : "LBP",
    "description" : "LIBANON - POUNDS"
  },
  {
    "unCode" : "LTL",
    "description" : "LITOUWEN - LITAS"
  },
  {
    "unCode" : "MMK",
    "description" : "MYANMAR(BURMA) - KYATS"
  },
  {
    "unCode" : "PAB",
    "description" : "PANAMA - BALBOA"
  },
  {
    "unCode" : "SYP",
    "description" : "SYRIE - POND"
  },
  {
    "unCode" : "TMM",
    "description" : "TURKMENISTAN - MANATS"
  },
  {
    "unCode" : "TZS",
    "description" : "TANZANIA - SHILLING"
  },
  {
    "unCode" : "UYU",
    "description" : "URUGUAY - PESOS"
  },
  {
    "unCode" : "XDR",
    "description" : "IMF SPECIAL DRAWING RIGHTS"
  },
  {
    "unCode" : "AFA",
    "description" : "AFGHANISTAN"
  },
  {
    "unCode" : "ALL",
    "description" : "ALBANIE"
  },
  {
    "unCode" : "ARS",
    "description" : "ARGENTIE"
  },
  {
    "unCode" : "BAM",
    "description" : "BOSNIE/HERZEGOVINA"
  },
  {
    "unCode" : "CDF",
    "description" : "CONGO/KINSHASA"
  },
  {
    "unCode" : "CUP",
    "description" : "CUBA"
  },
  {
    "unCode" : "DJF",
    "description" : "DIJBOUTI"
  },
  {
    "unCode" : "ERN",
    "description" : "ERITREA - NAKFA"
  },
  {
    "unCode" : "FKP",
    "description" : "FALKLAND ISLANDS - POUNDS"
  },
  {
    "unCode" : "GMD",
    "description" : "GAMBIA - DALASI"
  },
  {
    "unCode" : "LSL",
    "description" : "LESOTHO - MALOTI"
  },
  {
    "unCode" : "LYD",
    "description" : "LIBIE - DINARS"
  },
  {
    "unCode" : "MDL",
    "description" : "MOLDAVIE - LEI"
  },
  {
    "unCode" : "MGA",
    "description" : "MADAGASCAR - ARIARY"
  },
  {
    "unCode" : "NAD",
    "description" : "NAMIBIE - DOLLARS"
  },
  {
    "unCode" : "OMR",
    "description" : "OMAN - RIAL"
  },
  {
    "unCode" : "PGK",
    "description" : "PAPUA NEW GUINEA - KINA"
  },
  {
    "unCode" : "PYG",
    "description" : "PARAGUAY - GUARANI"
  },
  {
    "unCode" : "SDD",
    "description" : "SOEDAN - DOLLARS"
  },
  {
    "unCode" : "SLL",
    "description" : "SIERRA LEONE - LEONES"
  },
  {
    "unCode" : "SVC",
    "description" : "EL SALVADOR - COLONES"
  },
  {
    "unCode" : "TOP",
    "description" : "TONGA - PA ANGA"
  },
  {
    "unCode" : "TRY",
    "description" : "TURKEYE - LIRA"
  },
  {
    "unCode" : "TVD",
    "description" : "TUVALU - TUVALU DOLLAR"
  }
]
